import React from 'react';
import classNames from 'classnames';

export default function Button(props) {
    const {
        text,
        type,
        onClick,
        disabled = false,
        large = false,
        style,
        ...restProps,
    } = props;

    const acceptableTypes = ['primary', 'secondary'];
    if (!acceptableTypes.includes(type)) {
        throw new Error(`type must be one of: ${acceptableTypes}`);
    }

    return (
        <button
            className={classNames('textbutton', `textbutton-skin-${type}`, { 'textbutton-super': large} )}
            onClick={onClick}
            disabled={disabled}
            style={{
                margin: 4,
                ...style,
            }}
            {...restProps}
        >
            {text}
        </button>
    );
}



// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/Button.js